import React, { useState, useEffect, useRef, MutableRefObject } from 'react';
import {
  Container,
  Grid,
  Paper,
  Divider,
  Tabs,
  Tab,
  useTheme,
  Theme,
  styled,
} from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import TopControlBar from 'src/summarizer/components/TopControlBar';
import InputBox from 'src/summarizer/components/InputBox';
import {
  InputControlsContainer,
  MobileControlsContainer,
  OutputControlsContainer,
} from 'src/summarizer/components/BottomControlBar';
import OutputBox from 'src/summarizer/components/OutputBox';
import { useDispatch, useSelector } from 'react-redux';
import {
  userChangedActiveTabAction,
  userUploadedFile,
} from 'src/summarizer/actions/controlActions';
import withQuillLayout from 'src/_common/hoc/QuillLayout';
// import SummaryDescription from 'src/summarizer/components/OLD_SummaryDescription.txt';
import SummarizerExplanation from 'src/summarizer/components/SummarizerExplanation';
import { toggleKeyboardAction } from 'src/_common/actions/commonActions';
import { APP_SETTINGS } from 'config/constants';
import LoadBar from 'src/_common/quillElements/spinner/LoadBar';
import { RootState } from 'src/_common/models/redux/store';
import getConfig from 'next/config';
import { addMiddleware, removeMiddleware } from 'redux-dynamic-middlewares';
import { trackSummarizerActions } from 'src/summarizer/reducers/middlewares/track';
import CONSTANTS from 'src/paraphraser/constants';
import { insertTextAtCursor } from 'core/utils';
import { changeInputTextAction } from 'src/summarizer/actions/quillActions';
import { extractKeywords } from '@Common/handlers/api';
import {
  hydrateStoreFromSession,
  loadingKeywords,
  setKeywords,
} from 'src/summarizer/actions/systemActions';
import { getNumberOfSentences } from 'src/summarizer/handlers/logic';
import { handleKeywordCasing } from '@Common/handlers/services';
import ExtensionUpsale from '@Common/components/ExtensionUpsale';
import QuillLocalStorage from 'core/utils/localStorageClient';
import dynamic from 'next/dynamic';
import QuillSessionStorage from 'core/utils/sessionStorageClient';

// import summarizerReducers from 'src/summarizer/reducers';
// import { ReduxStore } from 'src/_common/redux/store';

const { publicRuntimeConfig } = getConfig();

const SummarizerDrawerControlBar = dynamic(
  () => import('src/summarizer/components/SummarizerDrawerControlBar'),
  {
    ssr: false,
  }
);

const useStyles = makeStyles<Theme, { isDrawerOpen: boolean }>((theme) =>
  createStyles({
    bottomCotrolContainer: {
      position: 'sticky',
      bottom: 0,
    },

    bgColorbody: {
      backgroundColor: theme.palette.background.default,
      paddingLeft: (props) => (props.isDrawerOpen ? '24px' : '42px'),
      paddingRight: (props) => (props.isDrawerOpen ? '24px' : '42px'),
    },

    summarizeBox: {
      margin: '12px 0px',
    },

    summarizeBoxContant: {
      //  backgroundColor: theme.palette.background.paper,
    },

    summarizeBoxSticyHeader: {
      // borderBottom: `1px solid ${theme.palette.grey[100]}`,
      backgroundColor: theme.palette.grey[50],
    },

    summarizeBoxSticyFooter: {
      backgroundColor: theme.palette.grey[50],
    },

    indicator: {
      backgroundColor: 'transparent',
    },
    summrizerTab: {
      borderBottom: `1px ${theme.palette.divider} solid`,
      minHeight: '40px',
      // backgroundColor: 'white',
    },
    tab: {
      textTransform: 'inherit',
      fontSize: '14px',
      // color: '#6D6D6D',
      minHeight: '40px',
      position: 'relative',
      fontWeight: 600,
      lineHeight: 'normal',
      '&::after': {
        content: '" "',
        position: 'absolute',
        height: '2px',
        width: '80px',
        display: 'block',
        bottom: '-1px',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
    },
    activeTab: {
      fontWeight: 'bold',
      // color: theme.palette.secondary.main,
      '&::after': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  })
);

const StyledRootContainer = styled(Container)`
  && {
    padding-top: 25px;
    padding-bottom: 30px;
    flex-direction: column;
    flex-wrap: unset !important;
    display: flex;
  }
`;

function Summarize() {
  // const store: ReduxStore = useStore();
  // store?.injectAsyncReducer('smzr', summarizerReducers);
  const quillDrawer = useSelector((state: RootState) => state.common.quillDrawer);
  const classes = useStyles({ isDrawerOpen: !!quillDrawer });
  const theme = useTheme();
  const [isAlertOpen, setAlertOpen] = useState(false);
  const dispatch = useDispatch();
  const activeTab = useSelector((state: RootState) => state.smzr.controls?.activeTab);
  const isQuilling = useSelector((state: RootState) => state.smzr.controls.isQuilling);
  const platform = useSelector((state: RootState) => state.common.platform);
  const isChromeExtInstalled = useSelector(
    (state: RootState) => state.common.platform?.isChromeExtInstalled
  );
  // DO NOT replace below code with platform?.isMobile, it helps in responsive behavior
  const [isMobile, setIsMobile] = useState(platform?.isMobile || false);
  const isExtension = useSelector((state: RootState) => state.common.platform.isExtension);
  const isIE = useSelector((state: RootState) => state.common.platform.isIE);
  const isRecaptchaShown = useSelector((state: RootState) => state.common.recaptcha.isShown);
  const isKeyboardOpen = useSelector((state: RootState) => state.common.isKeyboardOpen);
  const summaryMode = useSelector((state: RootState) => state.smzr.controls.summaryMode);
  const [droppedFile, setDroppedFile] = useState<{ files: null | File[] }>({ files: null });
  const [fileUploadArticleScrapperObject, setFileUploadArticleScrapperObject] = useState({
    // isFileDropped: false,
    fileFormatAllowed: true,
    isFileDragStarted: false,
    showLoadingSpinner: false,
  });
  const [isYtBoxOpen, setIsYtBoxOpen] = useState(false);
  const [inputTextHandle, setInputTextHandle] = useState(false);

  const [showExtensionUpsellBanner, setShowExtensionUpsellBanner] = useState(false);
  const inputRef = useRef() as MutableRefObject<HTMLInputElement>;

  const handleWindowResize = () => {
    if (window.innerWidth < 600) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
    if (platform.isMobile) {
      if (window.innerHeight < APP_SETTINGS.INIT_WINDOW_HEIGHT - 50) {
        const klaviyoForms = document.getElementsByClassName(publicRuntimeConfig.KLAVIO_CLASSNAME);
        const activeEl = document.activeElement;
        if (!klaviyoForms || klaviyoForms.length !== 1 || !klaviyoForms[0].contains(activeEl)) {
          dispatch(toggleKeyboardAction(true));
        }
      } /* if (window.innerHeight >= APP_SETTINGS.INIT_WINDOW_HEIGHT - 50) */ else {
        dispatch(toggleKeyboardAction(false));
      }
    }
    // if (platform.isIos) handleRefresh();
  };

  const extractKeyWordFromText = (text: string) => {
    if (getNumberOfSentences(text) > 1 && summaryMode === 'abs') {
      extractKeywords(text)
        .then((response: any) => {
          const allKeywordsAvailable = Array.from(new Set(response?.data as string[]));
          const keywords = handleKeywordCasing(allKeywordsAvailable, text);
          dispatch(setKeywords(keywords));
        })
        .catch(() => {
          dispatch(loadingKeywords(false));
        });
    }
  };

  useEffect(() => {
    if (summaryMode === 'abs') extractKeyWordFromText(inputRef.current.innerText);
  }, [summaryMode]);

  useEffect(() => {
    addMiddleware(trackSummarizerActions);

    if (isRecaptchaShown && isQuilling) setAlertOpen(true);
    window.addEventListener('resize', handleWindowResize);

    return () => {
      removeMiddleware(trackSummarizerActions);
      window.removeEventListener('resize', handleWindowResize);
      if (isKeyboardOpen) dispatch(toggleKeyboardAction(false));
    };
  }, []);

  useEffect(() => {
    if (isExtension && platform.extensionMetaData?.type === 'ms-word') {
      let scrollVal = 'none';
      if (APP_SETTINGS.showScrollbar) {
        scrollVal = 'auto';
      }
      const scrollableElem = document.getElementById('extensionMidContainerWithScrollSmzr');
      if (scrollableElem) {
        scrollableElem.setAttribute('style', `-ms-overflow-style: ${scrollVal}`);
        // scrollableElem.style.'-ms-overflow-style' = scrollVal;
      }
    }
  });

  useEffect(() => {
    try {
      const smzrStore: any = JSON.parse(QuillSessionStorage.getInstance().get('smzr', '{}'));
      QuillSessionStorage.getInstance().delete('smzr');
      if (smzrStore && Object.keys(smzrStore).length) {
        if (smzrStore?.input && Object.keys(smzrStore?.input).length) {
          dispatch(hydrateStoreFromSession('INPUT', smzrStore?.input));
        }
        if (smzrStore?.output && Object.keys(smzrStore?.output).length) {
          dispatch(hydrateStoreFromSession('OUTPUT', smzrStore?.output));
        }
        if (smzrStore?.controls && Object.keys(smzrStore?.controls).length) {
          dispatch(hydrateStoreFromSession('CONTROLS', smzrStore?.controls));
        }
        if (smzrStore?.stats && Object.keys(smzrStore?.stats).length) {
          dispatch(hydrateStoreFromSession('STATS', smzrStore?.stats));
        }
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }, []);

  useEffect(() => {
    if (droppedFile.files !== null) {
      setDroppedFile({ files: null });
    }
  }, [droppedFile]);

  useEffect(() => {
    if (typeof isChromeExtInstalled === 'boolean') {
      const upsellBannerState =
        QuillLocalStorage.getInstance().get('showExtensionUpsellBannerSmzr', 'true') === 'true' &&
        !isChromeExtInstalled;
      setShowExtensionUpsellBanner(upsellBannerState);
    }
  }, [isChromeExtInstalled]);

  const onBannerCloseIconClick = () => {
    QuillLocalStorage.getInstance().set('showExtensionUpsellBannerSmzr', 'false');
    setShowExtensionUpsellBanner(false);
  };

  const getText = (text: string) => {
    if (inputRef?.current) {
      inputRef.current.focus();
      inputRef.current.contentEditable = 'true';
      inputRef.current.innerText = '';
    }
    if (isIE) {
      insertTextAtCursor(text);
    } else {
      document.execCommand('insertText', false, text);
    }
    setInputTextHandle(true);
    dispatch(changeInputTextAction(text));
    extractKeyWordFromText(text);
  };

  const setFileInfo = (fileName: string, fileType: string) => {
    if (
      fileType === 'application/pdf' ||
      fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ) {
      dispatch(userUploadedFile({ fileName, fileType }));
    } else {
      setFileUploadArticleScrapperObject({
        ...fileUploadArticleScrapperObject,
        fileFormatAllowed: false,
        isFileDragStarted: true,
      });
      const gridContainerRef = document.getElementById('inputGridContainerRef');
      if (gridContainerRef && gridContainerRef.style) {
        gridContainerRef.style.background = ' #FFDFDF';
        gridContainerRef.style.border = '1px solid #FD0000';
      }
    }
  };
  return (
    <>
      {/* Desktop mode */}
      {!isMobile && isExtension !== true && (
        <StyledRootContainer
          maxWidth={false}
          className={`${classes.bgColorbody} root-container home-container-gray`}
        >
          <Grid container alignItems="center" justifyContent="center">
            <Grid item xs={12} className="mid-container">
              {showExtensionUpsellBanner && (
                <ExtensionUpsale
                  onBannerCloseIconClick={onBannerCloseIconClick}
                  onBannerAddClick={() => setShowExtensionUpsellBanner(false)}
                  originComp="bannerSMZR"
                />
              )}
              <Paper
                elevation={3}
                className={classes.summarizeBox}
                style={{
                  borderRadius: '0px',
                }}
              >
                <Grid
                  container
                  className={classes.summarizeBoxSticyHeader}
                  style={{
                    position: 'sticky',
                    top: 53,
                    // backgroundColor: 'white',
                    zIndex: 1,
                    // borderRadius: '13px 13px 0 0',
                  }}
                  justifyContent="center"
                >
                  <TopControlBar inputRef={inputRef} />
                  <Divider
                    style={{
                      margin: 0,
                      borderLeft: 'none',
                      borderRight: 'none',
                      borderTop: '1px',
                      width: '100%',
                    }}
                  />
                </Grid>

                <Grid container>
                  <Grid item xs>
                    <InputBox
                      getText={getText}
                      fileUploadArticleScrapperObject={fileUploadArticleScrapperObject}
                      setFileUploadArticleScrapperObject={setFileUploadArticleScrapperObject}
                      setDroppedFile={setDroppedFile}
                      inputTextHandle={inputTextHandle}
                      setInputTextHandle={setInputTextHandle}
                      setFileInfo={setFileInfo}
                      droppedFile={droppedFile}
                      isYtBoxOpen={isYtBoxOpen}
                      setIsYtBoxOpen={setIsYtBoxOpen}
                      inputRef={inputRef}
                      extractKeyWordFromText={extractKeyWordFromText}
                    />
                  </Grid>
                  <Divider orientation="vertical" flexItem />
                  <Grid item xs>
                    <OutputBox />
                  </Grid>

                  <Grid container style={{ position: 'sticky', bottom: '0' }}>
                    <Grid
                      container
                      className={classes.summarizeBoxSticyFooter}
                      style={{ width: '49.98%' }}
                    >
                      <Grid item xs>
                        <InputControlsContainer
                          getText={getText}
                          setFileInfo={setFileInfo}
                          droppedFile={droppedFile}
                          // setFileUploadArticleScrapperObject={setFileUploadArticleScrapperObject}
                          // fileUploadArticleScrapperObject={fileUploadArticleScrapperObject}
                          // setInputTextHandle={setInputTextHandle}
                          // setIsYtBoxOpen={setIsYtBoxOpen}
                          // inputRef={inputRef as any}
                        />
                      </Grid>
                    </Grid>
                    <Divider orientation="vertical" flexItem />
                    <Grid item xs style={{ alignSelf: 'flex-end' }}>
                      <OutputControlsContainer />
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </StyledRootContainer>
      )}

      {isMobile && !isExtension && (
        <Grid container className="nd-mobile-container" alignItems="center">
          <Grid container direction="column">
            <Grid
              item
              style={{
                position: 'sticky',
                top: 0,
                zIndex: 9,
                backgroundColor: theme.palette.grey[50],
              }}
            >
              <Grid container direction="column">
                <Grid item>
                  <TopControlBar inputRef={inputRef} />
                </Grid>
                <Grid item>
                  {!isKeyboardOpen && (
                    <Tabs
                      className={classes.summrizerTab}
                      classes={{ indicator: classes.indicator }}
                      variant="fullWidth"
                      value={activeTab}
                      onChange={() =>
                        dispatch(
                          userChangedActiveTabAction(
                            activeTab === 'summarized' ? 'original' : 'summarized'
                          )
                        )
                      }
                      aria-label="disabled tabs example"
                    >
                      <Tab
                        label="Original"
                        value="original"
                        classes={{
                          selected: classes.activeTab,
                          root: classes.tab,
                        }}
                      />
                      <Tab
                        label="Summarized"
                        value="summarized"
                        classes={{
                          selected: classes.activeTab,
                          root: classes.tab,
                        }}
                      />
                    </Tabs>
                  )}
                </Grid>
              </Grid>
            </Grid>

            <Grid item hidden={activeTab === 'summarized'}>
              <InputBox
                getText={getText}
                fileUploadArticleScrapperObject={fileUploadArticleScrapperObject}
                setFileUploadArticleScrapperObject={setFileUploadArticleScrapperObject}
                setDroppedFile={setDroppedFile}
                inputTextHandle={inputTextHandle}
                setInputTextHandle={setInputTextHandle}
                setFileInfo={setFileInfo}
                droppedFile={droppedFile}
                isYtBoxOpen={isYtBoxOpen}
                setIsYtBoxOpen={setIsYtBoxOpen}
                inputRef={inputRef}
                extractKeyWordFromText={extractKeyWordFromText}
              />
            </Grid>
            <Grid item hidden={activeTab === 'original'}>
              <OutputBox />
            </Grid>
            {CONSTANTS.isProgressBarOn && (
              <LoadBar style={{ position: 'sticky', bottom: 50, margin: 0 }} loading={isQuilling} />
            )}
            <Grid item style={{ position: 'sticky', bottom: 0, width: '100%' }}>
              <MobileControlsContainer />
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* @TODO: FIX */}
      {/* {!ParaModel.isContenEditableFocusedForMobile() && ( */}

      {isExtension && (
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          style={{
            height: 'calc(100vh - 45px)',
            // backgroundColor: 'white',
            overflow: 'hidden',
          }}
        >
          <Grid item>
            <Grid container direction="column">
              <Grid item>
                <TopControlBar inputRef={inputRef} />
              </Grid>
              <Tabs
                className={classes.summrizerTab}
                classes={{ indicator: classes.indicator }}
                variant="fullWidth"
                value={activeTab}
                onChange={() =>
                  dispatch(
                    userChangedActiveTabAction(
                      activeTab === 'summarized' ? 'original' : 'summarized'
                    )
                  )
                }
                aria-label="disabled tabs example"
              >
                <Tab
                  label="Original"
                  value="original"
                  classes={{
                    selected: classes.activeTab,
                    root: classes.tab,
                  }}
                />
                <Tab
                  label="Summarized"
                  value="summarized"
                  classes={{
                    selected: classes.activeTab,
                    root: classes.tab,
                  }}
                />
              </Tabs>
            </Grid>
          </Grid>
          <Grid item container style={{ flex: 1, position: 'relative', overflowY: 'auto' }}>
            <Grid container direction="column">
              <Grid item hidden={activeTab === 'summarized'}>
                {/* <Grid container> */}
                <InputBox
                  getText={getText}
                  fileUploadArticleScrapperObject={fileUploadArticleScrapperObject}
                  setFileUploadArticleScrapperObject={setFileUploadArticleScrapperObject}
                  setDroppedFile={setDroppedFile}
                  inputTextHandle={inputTextHandle}
                  setInputTextHandle={setInputTextHandle}
                  setFileInfo={setFileInfo}
                  droppedFile={droppedFile}
                  isYtBoxOpen={isYtBoxOpen}
                  setIsYtBoxOpen={setIsYtBoxOpen}
                  inputRef={inputRef}
                  extractKeyWordFromText={extractKeyWordFromText}
                />
              </Grid>
              {/* </Grid> */}
              <Grid item hidden={activeTab === 'original'} id="extensionMidContainerWithScrollSmzr">
                <OutputBox />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="column">
              {CONSTANTS.isProgressBarOn && <LoadBar style={{ margin: 0 }} loading={isQuilling} />}

              <Grid item>
                <MobileControlsContainer />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}

      {!isExtension && !platform.native && (
        <Grid container className={classes.summarizeBoxContant}>
          {/* <SummaryDescription /> */}
          <SummarizerExplanation />
        </Grid>
      )}

      {/* )}  */}
    </>
  );
}
export default withQuillLayout({
  children: Summarize,
  drawerProp: SummarizerDrawerControlBar,
});
